module.exports = __webpack_public_path__ + "static/microsoft-powerapps-workflow-d1aa52fcc1921932a3d17500640493a9.png";